<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="store/feature-group/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { FeatureGroup } from '@/modules/store/data/feature-group/create'
	import { FeatureGroupService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return FeatureGroup;
			},

			service()
			{
				return new FeatureGroupService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>